import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { subscriptionFilters } from '@/components/Internal/EmailManagement/email-list-filters'
import { EmailSubscriptions } from '@/components/Internal/EmailManagement/EmailSubscriptions'

export const Route = createFileRoute(
  '/internal/system/operations/email/subscriptions',
)({
  validateSearch: listSearchValidator(subscriptionFilters),
  component: EmailSubscriptionsScreen,
})

function EmailSubscriptionsScreen() {
  const filters = useListFilters(subscriptionFilters, Route)

  return <EmailSubscriptions filters={filters} />
}
